import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Suspense } from "react/cjs/react.production.min";
import "./App.css";
import AuthProvider from "./utilities/Context/AuthProvider";
import loaderImg2 from "./utilities/Image/loader2.webp";
import Blogs from "./utilities/Pages/Blogs/Blogs";
import AddBlogs from "./utilities/Pages/Dashboard/AddItems/AddBlogs";
import AddProjects from "./utilities/Pages/Dashboard/AddItems/AddProjects";
import AdminRoute from "./utilities/Pages/Dashboard/AdminRoute";
import Dashboard from "./utilities/Pages/Dashboard/Dashboard";
import Login from "./utilities/Pages/Dashboard/Login";
import Error from "./utilities/Pages/Error/Error";
import Projects from "./utilities/Pages/Home/Projects/Projects";
import SingleProject from "./utilities/Pages/Home/Projects/SingleProject/SingleProject";

const Home = React.lazy(() => import("./utilities/Pages/Home/Home"));

function App() {
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    setLoader(true);
    const timer = setTimeout(() => {
      setLoader(false);
    }, 2000);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return (
    <AuthProvider>
      <div className="App  text-white relative">
        <div className="">
          <Router>
            <Routes>
              <Route
                path="/"
                element={
                  <Suspense
                    fallback={
                      <div className=" h-screen flex items-center justify-center">
                        <img src={loaderImg2} alt="loader" />
                      </div>
                    }
                  >
                    {loader ? (
                      <div className=" h-screen flex items-center justify-center">
                        <img src={loaderImg2} alt="loader" />
                      </div>
                    ) : (
                      <Home />
                    )}
                  </Suspense>
                }
              />

              <Route path="/blogs" element={<Blogs />} />
              <Route path="/projects" element={<Projects showAll={true} />} />
              <Route path="/admin-login" element={<Login />} />
              <Route path="/projects/:id" element={<SingleProject />} />
              <Route
                path="/admin-dashboard"
                element={
                  <AdminRoute>
                    <Dashboard />
                  </AdminRoute>
                }
              >
                <Route path="/admin-dashboard" element={<AddProjects />} />
                <Route path="add-blogs" element={<AddBlogs />} />
              </Route>

              <Route path="*" element={<Error />} />
            </Routes>
          </Router>
        </div>
      </div>
    </AuthProvider>
  );
}

export default App;
